const routes = {
  home: '/',
  old: '/old',
  goodie: '/goodie',
  demo: '/demo',
  imprint: '/imprint',
  policy: '/policy',
};

export default routes;
